'use client';

import React from 'react';
import * as SubframeUtils from '../utils';

interface RootProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  className?: string;
}

const Root = React.forwardRef<HTMLDivElement, RootProps>(function Root(
  { children, className, ...otherProps },
  ref,
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        'bg-default-background flex w-full flex-col overflow-hidden rounded-[16px] border border-solid border-neutral-200 shadow-sm',
        className,
      )}
      ref={ref}
      {...otherProps}
    >
      {children}
    </div>
  );
});

interface HeaderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: React.ReactNode;
  badge?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

const Header = React.forwardRef<HTMLDivElement, HeaderProps>(function Header(
  { title, badge, actions, className, ...otherProps },
  ref,
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        'flex items-center justify-between border-b border-solid border-neutral-100 px-6 py-6',
        className,
      )}
      ref={ref}
      {...otherProps}
    >
      <div className="flex items-center gap-2">
        {title ? (
          <h2 className="text-heading-3 font-heading-3 text-default-font">{title}</h2>
        ) : null}
        {badge ? <div>{badge}</div> : null}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
});

interface FooterProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  className?: string;
}

const Footer = React.forwardRef<HTMLDivElement, FooterProps>(function Footer(
  { children, className, ...otherProps },
  ref,
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        'bg-default-background border-t border-solid border-neutral-100 px-6 py-4',
        className,
      )}
      ref={ref}
      {...otherProps}
    >
      {children}
    </div>
  );
});

export const TableCard = Object.assign(Root, {
  Header,
  Footer,
});
